exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon_play_style[data-v-93e43bd4] {\n    margin-right: 1px;\n    margin-left: 1px;\n    margin-bottom: 1px;\n}\n", ""]);

// exports
